<template>
  <footer class="main-footer">
    <div class="pull-right hidden-xs">
      <b>Version</b> 1.2.1
    </div>
    <strong>Copyright &copy; 2019 <a href="https://www.zanzar.com.br">Zanzar</a></strong>
  </footer>
</template>

<script>
  export default {
    name: 'Footer',
    data () {
      return {
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/pages/components/Footer.vue